
/* injects from baggage-loader */

'use strict'
import { PlatesType } from '../../components/ui/types/plates';

import StageBaseController from '../stage-base.controller';

import { balloons } from './stage-three.const';

import setaAnterior from '_images/stage-three/seta_anterior_audio_pedido.png';
import setaProximo from '_images/stage-three/seta_proximo_audio_pedido.png';
import play from '_images/stage-three/play_audio_pedido.png';
import pause from '_images/stage-three/pause_audio_pedido.png';

export default class StageTwoController extends StageBaseController{
    constructor($log, $rootScope, $state, $timeout, $interval, Dialog, Trophies, Session, TTS) {
        'ngInject';        
        super($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, 'main.stage-three');

        this.TTS = TTS;
        this.nextRoute = 'main.stage-four';
        this.defaultLevel = 3;
        this.$interval = $interval;

        this.setaAnteriorImg = setaAnterior;
        this.setaProximoImg = setaProximo;
        this.playImg = play;
        this.pauseImg = pause;
        this.indexPlayPause = 0;

        this.btnPlayPause = [this.playImg,this.pauseImg];
        
        this.orderLabel = ["Entrada","Prato principal","Sobremesa","Bebida"];
        this.indexSpeak = 0;

        this.state = {
            expireIn: 15, // 15 minutes
            region: 'norte',
            sequence: [
                PlatesType.entrance,
                PlatesType.principal,
                PlatesType.dessert,
                PlatesType.drink
            ]
        };

        this.balloons = {
            step: 0,
            steps: balloons
        };

        this.notListening = true;

        this.$rootScope.$on('setCurrentTab', (event, data) => { 
            this.indexSpeak = data;
            this.TTS.clear();
        });

        //recebendo os pratos e somente selecionando da lista permitida

        this.auxStage = [];

        this.$rootScope.$on('selecaoPratos', (event, data) => { 
            this.selecaoPratos(data);
        });

        //testes

        this.auxaa = [];

    }


    $onInit(){
        super.$onInit();
        
    }

    openFail(){
        let msg = `O pedido não pôde ser confirmado.<br> Algum prato não foi registrado de forma correta.`;
        super.openFail(msg);
    }

    openSuccess(){
        let msg = `O pedido foi confirmado e enviado ao chef!`;
        super.openSuccess(msg);
    }    
    

    isValid(){
        let isValid = true;
                
        this.model.items.forEach((item, index) => {
            if(item.value) {
                if(item.value.title !== this.clientOrder[index]){

                    isValid = false;
                }
                this.state.sequence[index] !== item.value.type ? isValid = false : null;
            } else {
                isValid = false;
            }
        });

        return isValid;
    }


    speak(){
        if(this.notListening){
            this.notListening = false;
            this.indexPlayPause = 1;
            if(!this.TTS.speaking()){
                this.TTS.speak(this.orderToSpeak[this.indexSpeak], this.TTS.clear());
            }
            else{
                this.TTS.resume();
            }
            
        }
        else{
            if(this.TTS.speaking()){
                this.TTS.pause();
            }
            
            this.notListening = true;
            this.indexPlayPause = 0; 
        }

        let interval =  this.$interval(() => {
            console.log("Speaking...");

            if(!this.TTS.speaking()){
                this.indexPlayPause = 0;
                this.notListening = true;
                this.$interval.cancel(interval);
            }
        },500);

    }

    change(c){
        if(this.notListening){
            this.TTS.clear();
            this.indexSpeak= this.indexSpeak+c;

            if(this.indexSpeak < 0){
                this.indexSpeak = (this.clientOrder.length-1);
            }

            if(this.indexSpeak > (this.clientOrder.length-1)){
                this.indexSpeak = 0;
            }
        }
    }       

    onSubmitOrder(){
        return this.isValid2() ? this.openSuccess() : this.openFail();
    }   

    //testes

    isValid2(){
        let isValid = true;
                
        this.model.items.forEach((item, index) => {
            if(item.value) {
                if(!this.clientOrder.includes(item.value.title)){
                    isValid = false;
                }
                else{
                    this.auxaa[index] = item.value;
                }
                this.state.sequence[index] !== item.value.type ? isValid = false : null;
            } else {
                isValid = false;
            }
        });

        this.$rootScope.$emit('correctItems', this.auxaa);

        return isValid;
    }

    //testes
    
    //recebendo os pratos e somente selecionando da lista permitida

    randomizaPratos(categoria){
        let size = categoria.length;
        let random = Math.floor(Math.random() * size);
        let plate = categoria[random];

        categoria.splice(random,1);
        
        return plate;
    }

    selecaoPratos(data){
        let dataAux = JSON.parse(JSON.stringify(data));
        let tamanho = dataAux.length;

        //preenchendo o array
        for (let i = 0; i < tamanho; i++){
            this.auxStage[i] = dataAux[i];
        }

        //criando um novo pedido
        let order = {
            entrance:this.randomizaPratos(this.auxStage[0]),
            principal:this.randomizaPratos(this.auxStage[1]),
            dessert:this.randomizaPratos(this.auxStage[2]),
            drink:this.randomizaPratos(this.auxStage[3])           
        };

        //definindo os textos a serem lidos
        let entradas = "O cliente pediu as entradas: " + order.entrance.title;
        let pratos = "O cliente pediu o prato principal: " + order.principal.title;
        let sobremesas = "O cliente pediu a sobremesa: " + order.dessert.title;
        let bebidas = "O cliente pediu a bebida: " + order.drink.title;

        //definindo o pedido
        let clientOrder = [
            order.entrance.title,
            order.principal.title,
            order.dessert.title,
            order.drink.title
        ];

        //passando o pedido pra global
        this.clientOrder = clientOrder;

        //array do que vai ser falado
        this.orderToSpeak = [entradas,pratos,sobremesas,bebidas];
        
        //removendo artefatos dos textos
        for(let i = 0; i < this.orderToSpeak.length; i++){
            this.orderToSpeak[i] = this.orderToSpeak[i].replace('<small>','');
            this.orderToSpeak[i] = this.orderToSpeak[i].replace('(pedaço)','');
            this.orderToSpeak[i] = this.orderToSpeak[i].replace('</small>','');
            this.orderToSpeak[i] = this.orderToSpeak[i].trim();
        }
        
        //imprimindo os pedidos certos pra não ter que ouvir
        // this.$log.log(this.clientOrder);
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-three/stage-three.controller.js